import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const printerTypesAdapter = getAdapter({ idFieldName: 'value' });

const printerTypesSlice = createSlice({
  name: 'printerTypes',
  initialState: printerTypesAdapter.getInitialState(),
  reducers: {
    setPrinterTypes: (state, { payload: { printerTypes } }) => {
      printerTypesAdapter.setAll(state, printerTypes);
    },
  },
});

const selectors = printerTypesAdapter.getSelectors(({ printerTypes }) => printerTypes);

export const getPrinterTypes = (state) => selectors.selectAll(state);

export const {
  setPrinterTypes,
} = printerTypesSlice.actions;

export default printerTypesSlice.reducer;